import { WidgetQuickActions } from '@components-common/widgets';
import { DashboardPage, Page, PageWidgets } from '@components-common/layouts';
import { DashboardTemplate } from '@components-fabric';
import { materialsRoutes } from './building-data/materials.routes';
import { layerFunctionsRoutes } from './building-data/structural-layer-functions.routes';
import { buildingParametersRoutes } from './building-data/building-parameters.routes';
import { spaceFunctionsPresetsRoutes } from './presets/space-functions.screens';
import { spaceFunctionsRoutes } from './building-data/space-functions.screens';
import { componentDbRoutes } from './components/shared';
import { buildingParametersPresetsRoutes } from './presets/building-parameters.screen';
import { structureComponentsPresetsRoutes } from './presets/structure-components.screen';

/**
 * Configuration Object: dashboardScreen
 *
 * This configuration object defines the dashboard screen for the application. It includes settings for
 * the dashboard's ID, template, path, component, title, and widgets.
 *
 * Properties:
 * @property {string} id - The unique identifier for the dashboard.
 * @property {string} tmp - The template used for the dashboard.
 * @property {string} path - The path to the dashboard.
 * @property {React.ComponentType} Component - The main component to render the dashboard page.
 * @property {string} title - The title of the dashboard.
 * @property {Array<object>} widgets - An array of widget configurations to be displayed on the dashboard.
 *
 * Widgets Configuration:
 * @property {React.ComponentType} widgets[].Component - The component to render each widget.
 * @property {string} widgets[].title - The title of each widget.
 * @property {Array<string>} widgets[].items - The items/routes to be included in each widget.
 *
 * Example Usage:
 * import { dashboardScreen } from 'path-to-this-file';
 *
 * // Use dashboardScreen in a router or layout component
 *
 * @type {DashboardTemplate}
 */
export const dashboardScreen: DashboardTemplate = {
  id: 'components_database_dashboard',
  tmp: 'dashboard',
  path: '.',
  Component: DashboardPage,
  title: 'Components database',
  roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
  widgets: [
    {
      Component: WidgetQuickActions,
      title: 'Building data',
      items: [
        materialsRoutes.index,
        layerFunctionsRoutes.index,
        buildingParametersRoutes.index,
        spaceFunctionsRoutes.index,
      ],
      className: 'h-100',
    },

    {
      id: 'structure_data_widget',
      title: 'Structure data',
      Component: WidgetQuickActions,
      items: [
        componentDbRoutes.floor.components_db_componentsfloors,
        componentDbRoutes.wall.components_db_componentswalls,
        componentDbRoutes.window.components_db_componentswindows,
        componentDbRoutes.roof.components_db_componentsroofs,
      ],
      className: 'h-100',
    },
    {
      id: 'presets_widget',
      title: 'Presets',
      Component: WidgetQuickActions,
      items: [
        spaceFunctionsPresetsRoutes.index,
        buildingParametersPresetsRoutes.index,
      ],
      className: 'h-100',
    } as any,
  ],
};
